import { verifyPassport } from '@/api';
import LoadingView from '@/components/common/LoadingView';
import { routes } from '@/constants/routes.const';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { IVerifyPassportPayload } from '@/types/common.type';
import { isRefundableAirport } from '@repo/utils';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';

type ParamProps = {
  passportNumber: string;
};

function PassportRedirect() {
  const { passportNumber } = useParams() as ParamProps;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const targetPath = queryString.get('path');

  const { mutate: varifiedPassport } = useMutation(
    (payload: IVerifyPassportPayload) => verifyPassport(payload),
    {
      retry: false,
      onSuccess: ({
        departureDate,
        customerNation,
        airportRefundable,
        ...rest
      }) => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            passportNumber,
            nationality: customerNation,
            ...rest,
          },
        });
        departureDate && localStorage.setItem('departureDate', departureDate);
        customerNation &&
          localStorage.setItem('customerNation', customerNation);
        localStorage.setItem('login', passportNumber!);
        if (targetPath?.includes('inquiry')) {
          return history.push(`/${targetPath}`);
        }

        if (airportRefundable) {
          const isTransferWeb = localStorage.getItem(
            `${passportNumber}-transfer`,
          );
          if (isTransferWeb === 'true') {
            if (departureDate) {
              history.push({
                pathname: routes.home,
              });
            } else {
              history.push({
                pathname: '/departure',
              });
            }
            return;
          }

          const selectedAirport = localStorage.getItem(passportNumber);
          if (!selectedAirport) return history.push(routes.selectAirport);
          if (isRefundableAirport(selectedAirport)) {
            return history.push(routes.airport);
          }
        }
        history.push(`/${targetPath}`);
      },
    },
  );

  useEffect(() => {
    varifiedPassport({ passportNumber }!);
  }, [passportNumber]);

  return (
    <LoadingWrapper>
      <LoadingView />
    </LoadingWrapper>
  );
}

export default PassportRedirect;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
